import { COLORS, FONT_FAMILY } from '@Commons';
import styled from 'styled-components';

export const SideNavContainer = styled.nav`
  max-width: 240px;
  width: 100%;
  padding: 24px;
  background-color: ${COLORS.lightShadedGrey};
  display: flex;
  flex-direction: column;

  @media (max-width: 865px) {
    min-height: 100vh;
    max-width: 260px;
  }
`;

export const LogoContainer = styled.div`
  margin-bottom: 50px;
  margin-left: 8px;
  img {
    width: 120px;
    height: 21px;
    cursor: pointer;
  }
`;

export const NavList = styled.ul`
  list-style: none;
  display: flex;
  gap: 8px;
  flex-direction: column;
  .nav-list__item {
    a {
      text-decoration: none;
    }
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${COLORS.darkBurgundy};
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 18px;
    line-height: 24px;
    cursor: pointer;
    img {
      width: 16px;
      height: 16px;
    }
    padding: 8px 16px;
  }

  .nav-list__item.active {
    color: ${COLORS.brandPrimary};
    font-family: ${FONT_FAMILY.hellix.bold};
    line-height: 26px;
    background-color: ${COLORS.lightPinkBrd};
    border-radius: 999px;
  }
`;

export const MobileDivider = styled.div`
  height: 1px;
  border-bottom: 1px solid ${COLORS.brandPrimary};
  width: 100%;
`;
